import { graphql } from '../../../graphql/generated';

export const CATALOGS_QUERY = graphql(`
  query Catalogs($labId: ID!) {
    labCatalogs(labId: $labId) {
      id
      name
      description
    }

    labParameters(labId: $labId) {
      ...CatalogForm_Parameter
    }
  }
`);

export const CLONE_CATALOG_MUTATION = graphql(`
  mutation CloneCatalog($id: ID!) {
    cloneCatalog(id: $id) {
      id
    }
  }
`);

export const DELETE_CATALOG_MUTATION = graphql(`
  mutation DeleteCatalog($id: ID!) {
    deleteCatalog(id: $id)
  }
`);
